<template>
  <div class="main">
    <div class="header" @click="goBack">
      <cl-page-back
        class="cl_people_back"
        icon="page_back_white"
      ></cl-page-back>
      <span class="fs22 stage_name">{{ routerInfo.year }}年龄段集训</span>
    </div>
    <div class="content">
      <el-table
        :data="list"
        style="width: 100%"
        height="100%"
        :row-class-name="tableRowClassName"
        @row-click="goDetails"
      >
        <template #empty>
          <cl-no-data v-show="tableLoading" img-type="default"></cl-no-data>
        </template>
        <el-table-column label="集训名称" prop="name" />
        <el-table-column label="日期">
          <template slot-scope="{ row }">
            <span class="AkrobatR fs16">{{ row.date || "-" }}</span>
          </template>
        </el-table-column>
        <el-table-column :label="$t('camp.地点')" prop="place" />
      </el-table>
    </div>
  </div>
</template>

<script>
export default {
  name: "assemble",
  components: {},
  data() {
    return {
      routerInfo: {},
      tableLoading: false,
      list: [], //集训列表
    };
  },
  methods: {
    // 返回上一页
    goBack() {
      this.$router.push({
        path:
          this.$sg.ss.get("dataType") && this.$sg.ss.get("dataType") == "woman"
            ? "/home-woman"
            : "/home",
        // query: {
        //     year : this.$route.query.year
        // }
      });
    },
    // 更改表格class
    tableRowClassName({ rowIndex }) {
      if (rowIndex % 2 == 0) {
        return "Table_odd";
      }
    },
    // 通过文件名筛选文件列表
    getAssembleList() {
      this.list = [];
      const { year, formPath } = this.routerInfo;
      const params = {
        year,
      };
      formPath === "home-woman"
        ? this.getWomanAssembleData(params)
        : this.getAssembleData(params);
    },
    // 所有集训
    getAssembleData(params) {
      this.$server.getTrainingsList(params).then((res) => {
        this.list = res.data || [];
        this.tableLoading = this.list && this.list.length ? false : true;
      });
    },
    // 女子球员集训
    getWomanAssembleData(params) {
      this.$server.getWomanTrainingsList(params).then((res) => {
        this.list = res.data || [];
        this.tableLoading = this.list && this.list.length ? false : true;
      });
    },

    // 去详情
    goDetails(row) {
      this.$router.push({
        path: "/assemble-details",
        query: {
          ...this.$route.query,
          id: row.id,
          tenant_id: row.tenant_id,
          name: row.name,
        },
      });
    },
  },
  mounted() {
    this.routerInfo = this.$route.query;
    this.getAssembleList();
  },
};
</script>
<style lang='scss' scoped>
.main {
  position: relative;
  height: 100%;
  background-color: #f3f3f3;
  .header {
    display: flex;
    height: 115px;
    color: #fff;
    background: url("~@i/cfa/header_bg.png") center center no-repeat;
    background-size: 100% 100%;
    cursor: pointer;
    .cl_people_back {
      width: 10px;
      position: absolute;
      top: 18px;
      left: 24px;
    }
    .stage_name {
      box-sizing: border-box;
      padding: 13px 0 0 42px;
      line-height: 30px;
    }
  }
  .content {
    position: absolute;
    top: 62px;
    left: 24px;
    width: calc(100% - 48px);
    height: calc(100% - 24px - 62px);
    margin: 0 auto;
    background-color: #fff;
    border-radius: 4px;
    box-sizing: border-box;
    padding: 10px 16px;
  }
}
/deep/.el-table {
  color: #3a3a3a;
}
/deep/.el-table th.el-table__cell {
  padding: 10px 0;
  border-bottom: none;
  color: #81818a;
  font-size: 14px;
}
/deep/.el-table td.el-table__cell {
  padding: 20px 0;
  border-bottom: none;
}
/deep/ .el-table--group::after,
.el-table--border::after,
.el-table::before {
  background-color: transparent;
}
</style>
